<template>
  <div>
    <p>Select any awards associated with this contact.</p>
    <b-form class="form-horizontal" @submit="saveAwards">
      <b-form-group label="Award Selection" label-class="control-label">
        <autocomplete :source="awardsSearchApi"
                      inputClass="form-control"
                      placeholder="Search awards"
                      resultsValue="id"
                      :resultsDisplay="awardDisplay"
                      ref="awardAutocomplete"
                      clearAfterEntry
                      credentials="include"
                      :request-headers="requestHeaders"
                      @selected="selectAward"></autocomplete>
      </b-form-group>

      <b-table striped
                :items="form.awards"
                :fields="fields"
                thead-class="hide-header"
                small
                show-empty
                empty-text="No awards have been selected yet.">
          <template slot="cancel" slot-scope="data">
            <div @click="removeAward(data.item)" class="m-2"><font-awesome-icon icon="times" /></div>
          </template>
          <template slot="name" slot-scope="data">
            <div @click="removeAward(data.item)">{{ data.item.awardTitle }}</div>
          </template>
        </b-table>
      <slot name="buttons">

      </slot>
    </b-form>
  </div>
</template>

<script>
import Autocomplete from "../../components/autocomplete";
import * as _ from "lodash";

export default {
  data() {
    return {
      form: {
        awards: []
      },
      fields: [{ key: "cancel" }, { key: "name" }],
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    };
  },

  props: {
    awards: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },

  computed: {
    awardsSearchApi: function() {
      return process.env.VUE_APP_BASE_URI + "/api/Awards/?search=";
    }
  },

  components: {
    Autocomplete
  },
  methods: {
    cancel: function() {
      this.$emit("cancel");
    },

    saveAwards: function(event) {
      event.preventDefault();
      this.$emit("saveAwards", this.form.awards);
    },

    awardDisplay: function(award) {
      return (
        award.awardTitle +
        " (" +
        award.awardNumber +
        ")<br/>" +
        "PI: " +
        award.primaryInvestigator.firstName +
        " " +
        award.primaryInvestigator.lastName
      );
    },

    selectAward: function(autoselectResponse) {
      // check if award has already been added
      var found = _.find(this.form.awards, function(selectedAward) {
        return selectedAward.id === autoselectResponse.selectedObject.id;
      });
      if (!found) {
        this.form.awards.push(autoselectResponse.selectedObject);
      }
    },

    removeAward: function(award) {
      this.form.awards = _.reject(this.form.awards, function(formAward) {
        return formAward.id === award.id;
      });
    }
  },

  created() {
    this.form.awards = _.clone(this.awards);
  }
};
</script>

<style scoped>
.form-horizontal {
  font-size: 13px;
}

.award-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

.award-list {
  font-size: 16px;
}

.hide-header {
  display: none;
}
</style>
<style>
.hide-header {
  display: none;
}
</style>
